import axios from 'axios';
import {rootUrl} from './rootUrl.js';
export let trademark={

  fileUpload(params) {
    return axios.post(rootUrl + '/trademark/fileUpload', params)
  },
  //ai的图片查询,上传的是文件
  fileUpload2(params) {
    const formData = new FormData();
    for(let i in params){
      formData.append(i, params[i]);
    }
    return axios.post(rootUrl + '/trademark/fileUpload', formData)
  },
  //ai的图片查询,上传的是文件地址
  aiSimilarQuery(params) {
    return axios.post(rootUrl + '/tmInfo/queryTmInfoGraphByMulCountry', params)
  },
  //ai的文字查询
  getText(params) {
    //tmText为关键字
    // retrievalType取值full，part，pinyin，simword
    // 精确,包含,xx,近似
    return axios.post(rootUrl + '/tmInfo/queryTmInfoTextByMulCountry', params)
  },
  //文字生成图片
  generate(params) {
    return axios.post(rootUrl + '/trademark/generate', params)
  },
  getByComplete(params) {
    return axios.post(rootUrl + '/trademark/getByComplete', params)
  },
  getByTmtabData(params) {
    return axios.post(rootUrl + '/trademark/getByTmtabData', params)
  },
  getGlobalArea(params) {
    return axios.post(rootUrl + '/trademark/getGlobalArea', params)
  },
  getGroupTmtabData(params) {
    return axios.post(rootUrl + '/trademark/getGroupTmtabData', params)
  },
  getNice(params) {
    return axios.post(rootUrl + '/trademark/getNice', params)
  },
//  商标分类(无需登录)
  getNiceByLang(params) {
    return axios.post(rootUrl + '/trademark/getNiceByLang', params)
  },
  //省市区,三次三级
  selectProvince(params) {
    return axios.post(rootUrl + '/trademark/selectProvince', params)
  },
  //省市区全部
  getProvinceAll(params) {
    return axios.post(rootUrl + '/trademark/getProvinceAll', params)
  },
  //预览页面信息
  getByPreview(params) {
    return axios.post(rootUrl + '/trademark/getByPreview', params)
  },
  //计算公式
  getFormula(params) {
    return axios.post(rootUrl + '/trademark/getFormula', params)
  },
  //所属领域
  getDomain(params) {
    return axios.post(rootUrl + '/trademark/getDomain', params)
  },
  //智能推荐
  addIntelligence(params) {
    return axios.post(rootUrl + '/trademark/addIntelligence', params)
  },
  //全类注册
  addWhole(params) {
    return axios.post(rootUrl + '/trademark/addWhole', params)
  },
  //存储上传文件路径
  uploadFile(params) {
    return axios.post(rootUrl + '/trademark/uploadFile', params)
  },
  //维也纳分类
  getVienna(params) {
    return axios.post(rootUrl + '/trademark/getVienna', params)
  },
  //维也纳分类所有
  getViennaAll(params) {
    return axios.post(rootUrl + '/trademark/getViennaAll', params)
  },
  //彩色生成黑白
  generateBlack(params) {
    const formData = new FormData();
    for(let i in params){
      formData.append(i, params[i]);
    }
    return axios.post(rootUrl + '/trademark/generateBlack', formData)
  },
  //获取所有申请人
  getApplicantList_trademark(params) {
    return axios.post(rootUrl + '/trademark/getApplicantList', params)
  },
  //搜索申请人
  getApplicants(params) {
    return axios.post(rootUrl + '/trademark/getApplicants', params)
  },
  //尼斯分类下的商品及服务,用于注册,有优先权的时候,输入英文检索出对应的标准服务.
  getGoods(params) {
    return axios.post(rootUrl + '/trademark/getGoods', params)
  },
  //标准非标准查询,用于注册,商标注册提交之前坚持有有优先权,用户输入的是标准服务还是非标准服务
  getStandard (params) {
    return axios.post(rootUrl + '/trademark/getStandard ', params)
  },
  //尼斯分类一类二类,用于查询,组合查询的分类展示
  getNiceCode(params) {
    return axios.post(rootUrl + '/trademark/getNiceCode', params)
  },
  //获取可注册性分析/续展的价格
  getPrice(params) {
    return axios.post(rootUrl + '/trademark/getPrice', params)
  },
  //续展添加验证
  insertExtendValidate(params) {
    return axios.post(rootUrl + '/trademark/insertExtendValidate', params)
  },
  //未完成订单续展付款验证
  renewalToPay(params) {
    return axios.post(rootUrl + '/trademark/renewalToPay', params)
  },
  //续展添加
  insertExtend(params) {
    return axios.post(rootUrl + '/trademark/insertExtend', params)
  },
  //续展添加详情
  insertExtendDetail(params) {
    return axios.post(rootUrl + '/trademark/insertExtendDetail', params)
  },
  //续展修改预览
  getExtend(params) {
    return axios.post(rootUrl + '/trademark/getExtend', params)
  },
  selectCountryList(params) {
    return axios.post(rootUrl + '/country/selectCountryList', params)
  },
  //邮箱验证码
  sendVerifyCode(params) {
	var qs = require('qs'); 
    return axios.post((window.location.origin == 'https://mservice.kangxin.com') ? "https://msso.kangxin.com/sendVerifyCode" : "http://mtestsso.kangxin.com/sendVerifyCode", qs.stringify({
        email:params.email
      }), {
    	headers: { 
    		'Content-Type': 'application/x-www-form-urlencoded'
    	}
    	});
  },
//邮箱注册
  doSimpleRegister(params) {
    var qs = require('qs'); 
      return axios.post((window.location.origin == 'https://mservice.kangxin.com') ? "https://msso.kangxin.com/doSimpleRegister.do" : "http://mtestsso.kangxin.com/doSimpleRegister.do", qs.stringify({
          email:params.email,
          corpName:params.corpName,
          contacts:params.contacts,
          phone:params.phone,
          regCode:params.regCode,
          // country:this.priorityCountry.list[this.priorityCountry.choosed].id,
          verifyCode:params.verifyCode,
          password:params.password
        }), {
        headers: { 
          'Content-Type': 'application/x-www-form-urlencoded'
        }
        });
    },
};



// WEBPACK FOOTER //
// ./src/service/trademark.js